<template>
  <transition name="fade">
    <router-view></router-view>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  watch:{
    displayName:{
        handler (val){
        //判断是否有用户名 然后调用获取当前用户拥有的数据源配置 数据
          if(val!=''){
            this.hoverShowName();
            this.$store.dispatch("dataDictionary/getUserOptionData")
          }
        }
    }
  },
  computed: {
        ...mapState({
            displayName: state =>  state.user.userinfo.displayName,
        })

  },
  created(){
    this.$store.dispatch('dataDictionary/getRegionTree', '');
  },
  methods: {
    // 系统登录用户名hover显示
    hoverShowName() {
        this.$nextTick(()=>{
                setTimeout(()=>{
                    $("span.el-dropdown-link").attr(
                "title",
                this.$store.state.user.displayName
                );
                // const dom=document.getElementsByClassName('site-navbar__brand-lg')[0]
                // const that=this
                // dom.onclick=function(event){
                //     event.preventDefault();
                //     that.$router.push({ name: 'home' })
                // }
                },2000)
        })
    },

  }
};
</script>
